// extracted by mini-css-extract-plugin
module.exports = {"image":"_image_image_4jaFK","sideImage":"_image_sideImage_1Prf7","shadow":"_image_shadow_tzSun","showOnlyMobile":"_image_showOnlyMobile_6xNeb"};